<sm-title-bar pageTitle="{{ 'qr_code.title' | translate }}" [backWithParams]="true"> </sm-title-bar>
<div class="merchant_detail_sec" *ngIf="!loader">
    <div class="mrt_offe">

            <div class="row">
              <div class="col-sm-12">
                <div class="row">
        <div class="col-sm-12 col-md-12 col-12" >
          <div class="drt_head">
          </div>
          <div class="list_user">
            <mat-card appearance="outlined">
            <a href="javascript:void(0)" class="admin_category">
              <div class="card_header chead">
                <div class="adm_set">
                  <div>
                    <span class="name_cont">Business kiosk QR code</span>
                  </div>
                </div>
              </div>
              <div #captureContainer>
                <div class="card_body cbody" *ngIf="QRAvailable == true">
                  <div class="canvas_cont" >
                      <div  style="display: inline-block; padding: 30px;">
                        <canvas #qrCodeCanvas></canvas>
                        <div style=" margin-top: 10px;">
                            <h4>{{QRdata.qrCode}}
                            </h4>
                        </div>
                        
                      </div>
                    </div>
                </div>
                <div class="card_body" *ngIf="QRAvailable == false">
                  <div class="palceholder_imgt_sw">
                    <img src="../../assets/images/placeholder-img.png" alt="placeholder-QR"/>
                </div>
                  <div class="canvas_cont" >
                      <div style="display: inline-block; padding: 20px;">
                        <p style="font-size: 16px;color: #646464;font-weight: 500; padding-top: 12px;">No business kiosk QR code generated.</p>
                      </div>
                    </div>
                </div>
              </div>
              <div class="download_btn" *ngIf="QRAvailable == true">
                <button mat-flat-button color="accent" (click)="downloadQR()">{{ 'qr_code.download' | translate }}</button>
              </div>

              <div class="download_btn" style="text-align: center;    margin-bottom: 40px;" *ngIf="QRAvailable == false">
                <button mat-flat-button color="accent" (click)="generateQR('3')">{{ 'qr_code.generate' | translate }}</button>
              </div>
              
            </a>
          </mat-card>
          <mat-card class="lk-booking-card" *ngIf="QRAvailable == true">

  <div class="lk-header" >
    <h3 class="lk-title">Business Kiosk link</h3>
  </div>
  <mat-form-field appearance="outline" class="lk-form-field">
    <input matInput
           class="lk-input"
           [(ngModel)]="qrLink"
           readonly>
    <button (click)="copyInputMessage()" mat-icon-button
            matSuffix
            class="lk-copy-btn"
            >
      <mat-icon style="    position: relative;
    bottom: 5px;
    right: 7px;">content_copy</mat-icon>
    </button>
  </mat-form-field>
</mat-card>
          </div>
        </div>
        <!-- <div class="col-sm-6 col-md-6 col-12" *ngIf="toShowHome == true">
          <div class="drt_head">
          </div>
          <div class="list_user">
            <mat-card appearance="outlined">
            <a href="javascript:void(0)" class="admin_category">
              <div class="card_header chead">
                <div class="adm_set">
                  <div>
                    <span class="name_cont">{{ 'qr_code.subtitle2' | translate }}</span>
                  </div>
                </div>
              </div>
              <div #captureContainer2>
                <div class="card_body cbody" *ngIf="homeQRAvailable == true">
                  <div class="canvas_cont" >
                      <div  style="display: inline-block; padding: 30px;">
                        <canvas #qrCodeCanvas2></canvas>
                        <div style=" margin-top: 10px;">
                            <h4>{{homeQRdata.qrCode}}
                            </h4>
                        </div>
                        
                      </div>
                    </div>
                </div>
                <div class="card_body" *ngIf="homeQRAvailable == false">
                  <div class="palceholder_imgt_sw">
                    <img src="../../assets/images/placeholder-img.png" alt="placeholder-QR"/>
                </div>
                  <div class="canvas_cont" >
                      <div style="display: inline-block; padding: 20px;">
                        <p style="font-size: 16px;color: #646464;font-weight: 500; padding-top: 12px;">{{ 'qr_code.placeholder2' | translate }}</p>
                      </div>
                    </div>
                </div>
              </div>
              <div class="download_btn" *ngIf="homeQRAvailable == true">
                <button mat-flat-button color="accent" (click)="downloadQR2()">{{ 'qr_code.download' | translate }}</button>
              </div>

              <div class="download_btn" style="text-align: center;    margin-bottom: 40px;" *ngIf="homeQRAvailable == false">
                <button mat-flat-button color="accent" (click)="generateQR('0')">{{ 'qr_code.generate' | translate }}</button>
              </div>
              
            </a>
          </mat-card>
          </div>
        </div>
              
        <div class="col-sm-6 col-md-6 col-12" *ngIf="toShowVirtual == true">
          <div class="drt_head">
          </div>
          <div class="list_user">
            <mat-card appearance="outlined">
            <a href="javascript:void(0)" class="admin_category">
              <div class="card_header chead">
                <div class="adm_set">
                  <div>
                    <span class="name_cont">Virtual Service QR Code</span>
                  </div>
                </div>
              </div>
              <div #captureContainer3>
                <div class="card_body cbody" *ngIf="virtualQRAvailable == true">
                  <div class="canvas_cont" >
                      <div  style="display: inline-block; padding: 30px;">
                        <canvas #qrCodeCanvas3></canvas>
                        <div style=" margin-top: 10px;">
                            <h4>{{virtualQRData.qrCode}}
                            </h4>
                        </div>
                        
                      </div>
                    </div>
                </div>
                <div class="card_body" *ngIf="virtualQRAvailable == false">
                  <div class="palceholder_imgt_sw">
                    <img src="../../assets/images/placeholder-img.png" alt="placeholder-QR"/>
                </div>
                  <div class="canvas_cont" >
                      <div style="display: inline-block; padding: 20px;">
                        <p style="font-size: 16px;color: #646464;font-weight: 500; padding-top: 12px;">No virtual QR code generated</p>
                      </div>
                    </div>
                </div>
              </div>
              <div class="download_btn" *ngIf="virtualQRAvailable == true">
                <button mat-flat-button color="accent" (click)="downloadQR3()">{{ 'qr_code.download' | translate }}</button>
              </div>

              <div class="download_btn" style="text-align: center;    margin-bottom: 40px;" *ngIf="virtualQRAvailable == false">
                <button mat-flat-button color="accent" (click)="generateQR('2')">{{ 'qr_code.generate' | translate }}</button>
              </div>
              
            </a>
          </mat-card>
          </div>
        </div> -->
      </div>
</div>



<!-- Bueaty content start -->

<!-- Bueaty content end -->





<!-- fitness content start -->

<!-- fitness content end -->



</div>

  
      </div>
      </div>